import { put, all, call, takeLatest } from 'redux-saga/effects'
import { Types, Creators } from './index'
import CertificateRequests from '../../../services/requests/CertificateRequests'

function * getCertificates (action) {
  try {
    const data = yield CertificateRequests.get(action.params)
    console.log('Certificates data from API:', data)
    yield put(Creators.getCertificatesSuccess(
      data.certificates,
      data.total,
      data.pages,
      data.current_page
    ))
  } catch (error) {
    yield put(Creators.getCertificatesFailure(error))
  }
}

export default all([
  takeLatest(Types.GET_CERTIFICATES_REQUEST, getCertificates)
])
